"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const fixImperialUnit = (key, units) => {
    if (key === "height" && units.main === "ft")
        return units.main;
    return units.sub;
};
const assembleTranslation = (translation, value, weightUnit, lengthUnits) => {
    const unit = value === "weight" ? weightUnit : fixImperialUnit(value, lengthUnits);
    return `${translation}${unit}`;
};
const propsToJSX = ({ leftMeasurement, rightMeasurement, translations, unitOfWeight, unitsOfLength, areSelectsValuesEqual }) => {
    const JSX = [];
    for (const value in translations) {
        JSX.push((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)("div", { children: leftMeasurement[value] }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: assembleTranslation(translations[value], value, unitOfWeight, unitsOfLength) }, void 0), !areSelectsValuesEqual && ((0, jsx_runtime_1.jsx)("div", { children: rightMeasurement[value] }, void 0))] }, value));
    }
    return JSX;
};
exports.default = (props) => {
    var _a;
    return ((0, jsx_runtime_1.jsxs)(Container, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: props.leftMeasurement.createdAt }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: props.areSelectsValuesEqual ? "" : (_a = props.rightMeasurement) === null || _a === void 0 ? void 0 : _a.createdAt }, void 0)] }, void 0), propsToJSX(props)] }, void 0));
};
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;

  & > div:first-of-type {
    display: flex;
    justify-content: space-between;
    padding: ${({ theme }) => `0 ${theme.spacings.xxs}`};

    & P {
      font-size: 0.875rem;
    }
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding: ${({ theme }) => `0 ${theme.spacings.m}`};
  }
`;
const Wrapper = styled_components_1.default.div `
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacings.s};

  & > div {
    align-items: center;
    background-color: ${({ theme }) => theme.colors.silverLighten40};
    border-radius: ${({ theme }) => theme.utils.radius};
    color: ${({ theme }) => theme.colors.greyLighten40};
    display: flex;
    font-weight: 500;
    font-size: 0.75rem;
    justify-content: center;
    width: 2.5rem;
  }

  p {
    align-items: center;
    display: flex;
    font-size: 0.875rem;
    justify-content: center;
    margin-bottom: 0;
    width: 8rem;
  }

  p:first-letter {
    text-transform: capitalize;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    justify-content: space-between;
  }
`;
//# sourceMappingURL=Compare.js.map